import React, { memo } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "store/hooks/hooks";
import {
  selectCartStatus,
  selectCartError,
  selectCartCount,
} from "store/slices/cartSlice";
import LucideIcon from "../../utils/LucideIcon";

function CartIconOnly() {
  const cartCount = useAppSelector(selectCartCount);
  const status = useAppSelector(selectCartStatus);
  const error = useAppSelector(selectCartError);

  return (
    <Link
      to="/collection"
      className="relative group w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full inline-flex items-center justify-center transition-colors"
    >
      <div className="w-fit p-1 h-3.5 flex items-center justify-center bg-gradient-to-r from-blue-500 to-purple-500 absolute top-1.5 right-1.5 rounded-full text-[10px] leading-none text-white font-medium">
        <span className="mt-[1px]">
          {status === "loading" ? "…" : error ? "!" : cartCount}
        </span>
      </div>
      <LucideIcon name="ShoppingCart" />
    </Link>
  );
}

export default memo(CartIconOnly);
